export function listingStepsHover() {
  const listItems = document.querySelectorAll(".listitem");
  let lastHoveredItem = null;

  listItems.forEach((listItem) => {
    listItem.addEventListener("mouseover", () => {
      if (lastHoveredItem) {
        lastHoveredItem.classList.remove("active");
      }

      listItem.classList.add("active");

      lastHoveredItem = listItem;
    });

    listItem.addEventListener("mouseout", () => {
      listItems.forEach((item) => {
        if (item !== lastHoveredItem) {
          item.classList.remove("active");
        }
      });
    });
  });
}
